export default function calculateIncrement(min: number, max: number): number {
    return (max - min) / 5000;
}
